import WebCheckoutEntry from "@/components/WebCheckoutEntry";

export default function CheckoutPage() {
  return <WebCheckoutEntry />;
}
